import {
  accentColors,
  lighterVariations,
  secondaryColors,
  StyledLoadingPlaceholder,
} from '@tryhackme/thm-ui-components';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { TaskProgressStatus } from './room-footer.types';

export const StyledRoomFooterWrapper = styled.div<{
  $hasAnsweredCorrectly: boolean;
  $isTabletAndNotSplitScreen: boolean;
  $isDarkMode: boolean;
}>`
  display: flex;
  width: 100%;
  min-height: 10rem;
  ${({ $hasAnsweredCorrectly }) => $hasAnsweredCorrectly && 'transition: background 500ms ease-in'};
  background: ${({ $hasAnsweredCorrectly, theme, $isDarkMode }) => {
    if ($hasAnsweredCorrectly) {
      return $isDarkMode ? theme.colors.background.active : lighterVariations.success.lighter;
    }
    return $isDarkMode ? theme.colors.secondary.light : secondaryColors.grey[100];
  }};
  justify-content: space-between;
  padding: 3.2rem ${({ $isTabletAndNotSplitScreen }) => ($isTabletAndNotSplitScreen ? '7.4rem' : '2.4rem')};
  align-items: center;
  bottom: 0;
  flex-direction: column;
  gap: 2.4rem;
`;

export const StyledTasksProgressWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledTaskProgressStatus = styled.div<{ $status: TaskProgressStatus }>`
  border-radius: 5rem;
  height: 1rem;
  width: 6.4rem;
  background: ${({ $status }) => {
    if ($status === TaskProgressStatus.COMPLETED) {
      return accentColors.info.light;
    }
    if ($status === TaskProgressStatus.IN_PROGRESS) {
      return accentColors.info.dark;
    }
    return secondaryColors.grey[400];
  }};
`;

export const StyledTaskTooltipText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const StyledCorrectAnswerText = styled.span<{ $isDarkMode: boolean }>`
  font-size: 1.8rem;
  font-weight: 600;
  color: ${({ $isDarkMode, theme }) => ($isDarkMode ? theme.colors.primary.main : accentColors.success.light)};
`;

export const StyledCorrectAnswerIcon = styled(FontAwesomeIcon)<{ $isDarkMode: boolean }>`
  width: 1.8rem;
  height: 1.8rem;
  color: ${({ $isDarkMode, theme }) => ($isDarkMode ? theme.colors.primary.main : accentColors.success.light)};
`;

export const StyledCorrectAnswerMessageWrapper = styled.div<{ $hasAnsweredCorrectly: boolean }>`
  display: flex;
  gap: 1rem;
  align-items: center;
  transition: ${({ $hasAnsweredCorrectly }) => $hasAnsweredCorrectly && 'opacity 1s ease-in'};
  opacity: ${({ $hasAnsweredCorrectly }) => ($hasAnsweredCorrectly ? 1 : 0)};
  height: ${({ $hasAnsweredCorrectly }) => ($hasAnsweredCorrectly ? 'auto' : 0)};
`;

export const StyledLoading = styled.div`
  ${StyledLoadingPlaceholder}
  width: 100%;
  height: 10rem;
  position: absolute;
  bottom: 0;
`;
